export default __webpack_public_path__ + "static/media/app-bg-05.2916435a.png";